<script>

    import BundleCardsComponent from '../../components/pagesbuilder/dynamic-components/BundleCardsComponent.vue';
    import PreviewComponent from './PreviewComponent.vue';
    export default {
        mixins: [
            PreviewComponent,
            BundleCardsComponent
        ],
        data () {
            return {
              enableHref: true,
            }
        },
        methods: {
            addListeners() {
                this.componentNode.querySelectorAll('[data-bundle-uid]').forEach((el) => {
                    if (el.dataset.bundleUid) {
                        el.addEventListener('click', () => {
                            location.href = `${window.clientURL}/bundle/${el.dataset.bundleUid}`
                        });
                    }
                });
            },
            loadMoreClicked () {
                let rows = this.getRows();

                if (rows) {
                    rows++
                } else {
                    rows = 1;
                }

                this.changeMyData({
                    rows
                })
            },
        }
    }
</script>
